import { useEffect } from 'react';
import { ROLES } from '../core/constants/roles';
import { isAppVersionSupported } from '../core/config/appVersion';
import { APP_VERSION } from '../config/appVersion';
import { isMaintenanceActive } from '../core/config/remoteConfigPolicy';
import { useRemoteConfig } from '../hooks/useRemoteConfig';
import { usePlatformConfig } from '../contexts/PlatformConfigContext';
import type { AppUser } from '../types';

interface MaintenanceGuardProps {
  user: AppUser;
  onBlocked: () => void;
}

/** Signs out non-god users when maintenance mode is active. */
export function MaintenanceGuard({ user, onBlocked }: MaintenanceGuardProps) {
  const remote = useRemoteConfig();
  const { config: platformConfig } = usePlatformConfig();
  const maintenance = isMaintenanceActive(
    remote.maintenanceMode,
    platformConfig.featureFlags.maintenance_mode,
  );

  useEffect(() => {
    if (!isAppVersionSupported(APP_VERSION, remote.minAppVersion)) {
      onBlocked();
      return;
    }
    if (!maintenance || user.role === ROLES.GOD) return;
    onBlocked();
  }, [maintenance, remote.minAppVersion, user.role, onBlocked]);

  return null;
}
